/* eslint-disable import/no-cycle */
import { setBreadcrumb } from './index';
import Parent from '../views/Parent.vue';
import CmerList from '@/views/master-data/CmerList.vue';
import BranchCodeList from '@/views/master-data/BranchCodeList.vue';
import ChannelProviderList from '@/views/master-data/ChannelProviderList.vue';
import ClosedMerchantCategoryList from '@/views/master-data/ClosedMerchantCategoryList.vue';
import Nns from '@/views/nns/Nns.vue';


const masterDataRoute = {
  path: '/master-data',
  name: 'Master Data',
  meta: {
    title: 'BNI QRIS - Master Data',
    appBarTitle: 'Master Data',
  },
  component: Parent,
  children: [
    {
      path: '/master-data/master-cmer',
      meta: {
        title: 'BNI QRIS - Merchant Category Segment',
        appBarTitle: 'Merchant Category Segment',
        breadcrumbs: () => [
          setBreadcrumb('Master Data', '/master-data', true),
          setBreadcrumb('Merchant Category Segment', '/master-data/master-cmer'),
        ],
      },
      component:CmerList ,
      name: 'Merchant Category Segment',
    },
    {
      path: '/master-data/master-branch-code',
      meta: {
        title: 'BNI QRIS - Branch Code (BC/KO)',
        appBarTitle: 'Branch Code (BC/KO)',
        breadcrumbs: () => [
          setBreadcrumb('Master Data', '/master-data', true),
          setBreadcrumb('Branch Code (BC/KO)', '/master-data/master-branch-code'),
        ],
      },
      component:BranchCodeList ,
      name: 'Branch Code (BC/KO)',
    },
    {
      path: '/master-data/channel-provider',
      meta: {
        title: 'BNI QRIS - Channel Provider',
        appBarTitle: 'Channel Provider',
        breadcrumbs: () => [
          setBreadcrumb('Master Data', '/master-data', true),
          setBreadcrumb('Channel Provider', '/master-data/channel-provider'),
        ],
      },
      component: ChannelProviderList,
      name: 'Channel Provider',
    },
    {
      path: '/master-data/kategori-penutupan-merchant',
      meta: {
        title: 'BNI QRIS - Kategori Penutupan Merchant',
        appBarTitle: 'Kategori Penutupan Merchant',
        breadcrumbs: () => [
          setBreadcrumb('Kategori Penutupan Merchant', '/master-data/kategori-penutupan-merchant', true),
          setBreadcrumb('List Kategori Penutupan Merchant', '/master-data/kategori-penutupan-merchant'),
        ],
      },
      component: ClosedMerchantCategoryList,
      name: 'Kategori Penutupan Merchant',
    },
    {
      path: '/master-data/nns-management',
      name: 'ListNns',
      meta: {
        title: 'BNI QRIS - List NNS',
        appBarTitle: 'List NNS',
        breadcrumbs: () => [
          setBreadcrumb('nns management', '/master-data/nns-management', true),
          setBreadcrumb('list nns', '/master-data/nns-management'),
        ],
      },
      component: Nns,
    },
  ],
  
};

export default masterDataRoute;
